module.exports = __webpack_public_path__ + "static/img/1_3_1.2e073f0e.jpg";